import Vector2 from './Vector2';
import Transform from './Transform';
import {load, player, enemies, gridSize} from './store';

export default class Robot {

    constructor (position = new Vector2(5, 5), commands = [], markings = []) {
        this.position = position;
        this.direction = new Vector2(0, -1);
        this.commands = commands;
        this.animatedPosition = new Transform(position);
        this.animatedPosition.parent = new Transform(new Vector2(-.35, -.35))
        this.animatedDirection = new Transform(this.direction);
        this.lasers = [];
        this.markings = markings;
    }

    update (delta) {
        this.animatedPosition.update(delta);
        this.animatedDirection.update(delta);
        return this;
    }

    fixedUpdate () {
        this.animatedPosition.goTo(this.position);
        this.animatedDirection.goTo(this.direction);
    }

    rotate (clockwise = true) {
        this.direction = new Vector2(this.direction.y * (clockwise ? -1 : 1), this.direction.x * (clockwise ? 1 : -1));
        return this;
    }

    move (distance, direction = this.direction) {
        let robots = [load(player), ...load(enemies)];
        for (let i = 0; i < distance; i++) {
            let newPosition = this.position.add(direction.unit()).clamp(new Vector2(0, 0), new Vector2(gridSize - 1, gridSize - 1));
            let blockingRobot = robots.filter(robot => {
                return robot !== this && robot.position.x === newPosition.x && robot.position.y === newPosition.y;
            })[0];
            if (blockingRobot) {
                blockingRobot.move(1, this.direction);
                if (blockingRobot.position.x !== newPosition.x || blockingRobot.position.y !== newPosition.y) {
                    this.position = newPosition;
                }
            } else {
                this.position = newPosition;
            }
        }
        return this;
    }

    shoot () {
        let robots = [load(player), ...load(enemies)];
        let firstHit = robots.filter(robot => {
            return robot !== this
                && Math.sign(robot.position.x - this.position.x) === this.direction.x
                && Math.sign(robot.position.y - this.position.y) === this.direction.y;
        }).reduce((firstHit, robot) => {
            let oldDistance = firstHit.subtract(this.animatedPosition.centre).magnitudeSquared;
            let newDistance = robot.animatedPosition.centre.subtract(this.animatedPosition.centre).magnitudeSquared;
            return newDistance < oldDistance ? robot.animatedPosition.centre : firstHit;
        }, this.animatedPosition.centre.add(this.direction.withMagnitude(12))).clamp(new Vector2(-.5, -.5), new Vector2(gridSize - .5, gridSize - .5));
        this.lasers = [{origin: this.animatedPosition.centre, target: firstHit}];
        setTimeout(() => {
            this.lasers = [];
        }, 500);
        return this;
    }

    runCommand () {
        this.commands[0].action(this);
        this.commands = [...this.commands.slice(1)];
        return this;
    }
}
